export default "__VITE_ASSET__DQfbK2_j__"